//* 绘图库
import Konva from "konva";
//* 组件属性
import type { GeneticInformationOrigin } from "./index";
import * as Canvas from "./canvas";

export const useComposable = () => {
    const refs = {
        origin: ref<GeneticInformationOrigin>()
    }

    //* 节点
    const nodes = {
        body: ref<HTMLDivElement>(),
        container: ref<HTMLDivElement>(),
        chromosome: ref<HTMLDivElement>(),
        attachments: ref<HTMLDivElement>(),
    };

    //* 静态属性
    const variable = {
        chromosome: shallowRef<Konva.Stage>(),
        attachments: shallowRef<Konva.Stage>(),
    };

    //* 函数库
    const methods = {
        //* 初始化函数
        init: (origin: GeneticInformationOrigin, spacing: number) => {
            //* 检测是否满足运行条件
            if (!nodes.container.value || !nodes.chromosome.value || !nodes.attachments.value) return;

            //* 基本信息初始化
            refs.origin.value = origin || {};

            //* 染色体画布初始化
            if (variable.chromosome.value) variable.chromosome.value.removeChildren();
            else {
                variable.chromosome.value = new Konva.Stage({ container: nodes.chromosome.value });
            }

            //* 基因上下游画布初始化
            if (variable.attachments.value) variable.attachments.value.removeChildren();
            else {
                variable.attachments.value = new Konva.Stage({ container: nodes.attachments.value });
            }

            //* 数据初始化
            const note = origin.chromosome.data.find((value) => value.end >= origin.chromosome.start && value.start <= origin.chromosome.start);
            const setting = {
                spacing: spacing,
                chromosome: 208,
                attachments: nodes.container.value.clientWidth - 210,
            };

            //* 检测是否需要绘制染色体标注
            if (note) {
                //* 实例化标注的文本对象
                const visual = new Konva.Text({ text: note.id, fontFamily: "sans-serif", fontStyle: "bold", fontSize: 14 });
                //* 计算对象的绘图区域（宽度）
                setting.chromosome = Math.ceil(visual.getTextWidth()) + 222;
                setting.attachments = nodes.container.value.clientWidth - setting.chromosome - 2;
            }

            //* 设置对象的绘图区域（宽度）
            variable.chromosome.value.width(setting.chromosome);
            variable.attachments.value.width(setting.attachments);

            //* 绘图模型
            Canvas.attachments.render(origin, variable.attachments.value, setting);
            Canvas.chromosome.render(
                origin,
                variable.chromosome.value,
                Object.assign(setting, {
                    size: nodes.body.value?.offsetHeight || 0,
                })
            );
        },
    };

    return { refs, nodes, methods };
};
